import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import * as Highcharts from 'highcharts';

import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StackchartServiceService } from './verticalStackChart.service';
import { CrosstabService } from 'src/app/common/services/crosstab.service';
import { SignificanceService } from 'src/app/common/services/significance.service';
import { COMMON_CONSTANTS } from '../../constants/common-constants';
import Stock from 'highcharts/modules/stock';

Stock(Highcharts);

const STACK_CONSOLIDATED_MIXED = 'IS/NA';
const STACK_CONSOLIDATED_ONLY_INSUFFICIENT = 'I/S';
const STACK_CONSOLIDATED_ONLY_NA = 'NA';

@Component({
  selector: 'app-stackChart',
  templateUrl: './verticalStackChart.component.html',
  styleUrls: ['./verticalStackChart.component.css'],
})

export class Stackedbarchart1Component implements OnInit, OnDestroy {
  LowBaseSample = COMMON_CONSTANTS.LowBase_Sample;
  InsufficientBaseSample = COMMON_CONSTANTS.InsufficientBase_Sample;
  @Input() insufficientBase: string = '';
  @Input() LowBase: string = '';
  DefaultConfidenceLevel: string = '95%';
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  seriesData: any[] = [];
  StackChartData: any[] = [];
  sampleSizeValues: any;
  chart: any;
  custom: any[] = [];
  ChartProperties: any;
  event: any;
  changeValue: any;
  significanceValue: any;
  significanceValue2: any;
  data: any;
  chartCategories: any;
  cleanedCategories: any[] = [];
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' | 'ascd' = 'ascd';
  colorDictionary:any=[];
  properties = [
    {
      "showLegend": true,
      "gridlines": false,
      "shadow": false,
      "legendPosition": "bottom",
      "stacking": 0,
      "darkTheme": false,
      "axisLabelOrientation": "horizontal",
      "chartTitlePosition": "center",
      "showDataLabel": true,
      "dataLabelPosition": "center",
      "dataLabelPositionPPT": "center",
      "datalabelOrientation": 0,
      "showRemaining": false,
      "plotBands": false,
      "axisImage": false,
      "lowSample": false,
      "gradientBarColor": false,
      "datalabelStyle": "significance2",
      "showNegative": false,
      "dataLabelColor": "black",
      "allowOverlap": true,
      "datalabelFormat": "percentage",
      "showPattern": false,
      "toolTipStyle": "default"
    }
  ]

  private splitHierarchyLevels(label: string): string[] {
    const s = String(label ?? '').trim();
    if (!s) {
      return [];
    }
    return s
      .split(/\s*:\s*/)
      .map((p) => p.trim())
      .filter((p) => p.length > 0);
  }

  private computeCommonHierarchyStripCount(labels: string[]): number {
    const normalized = labels.map((l) => String(l ?? '').trim()).filter((l) => l.length > 0);
    if (normalized.length < 2) {
      return 0;
    }
    const segmentLists = normalized.map((l) => this.splitHierarchyLevels(l));
    if (segmentLists.some((p) => p.length === 0)) {
      return 0;
    }
    const minLen = Math.min(...segmentLists.map((p) => p.length));
    let k = 0;
    while (k < minLen) {
      const seg0 = segmentLists[0][k];
      if (!segmentLists.every((parts) => parts[k] === seg0)) {
        break;
      }
      k++;
    }
    if (k === 0) {
      return 0;
    }
    const remainders = segmentLists.map((parts) => parts.slice(k));
    if (remainders.some((r) => r.length === 0)) {
      return 0;
    }
    return k;
  }

  private formatHierarchyDisplay(full: string, stripCount: number): string {
    if (stripCount <= 0) {
      return full == null ? '' : String(full);
    }
    const parts = this.splitHierarchyLevels(String(full));
    if (parts.length <= stripCount) {
      return String(full);
    }
    return parts.slice(stripCount).join(' : ');
  }

  ngOnInit(): void {

    this.LowBaseSample = this.LowBase == "" ? 0 : Number(this.LowBase);
    this.InsufficientBaseSample = this.insufficientBase == "" ? 0 : Number(this.insufficientBase);


    //this.getData().subscribe(
    //  (jsonData: any) => {
    //    this.data = jsonData[0];
    //    this.StackChartData = jsonData[0]['data'];
    //    this.ChartProperties = this.properties[0];
    //    this.renderChart2('chart-container', this.data['data'], this.ChartProperties);
    //  },
    //  (error: any) => {
    //    console.error('Error fetching data:', error);
    //  }
    //);

    this.dataSharingService.StackChartDataSubject$.subscribe(({ data, listOfCategory, Significance, ConfidenceLevel, numberType, chartType }) => {
      this.ChartProperties = this.properties[0];
      if (Significance == "None") {
        this.ChartProperties.datalabelStyle = '';
      }
      else {
        this.ChartProperties.datalabelStyle = 'change';
        this.DefaultConfidenceLevel = ConfidenceLevel;
      }
      // if (data.Data[0]['Series Name'].includes('mean')) {
      //   this.properties.datalabelFormat = '';
      // }
         if (data?.Data?.some(
      (item: any) =>
        item['Series Name']?.toString().toLowerCase().includes('mean')
    )) {
        this.ChartProperties.datalabelFormat = '';
      }
      this.data = data;
  // Preserve raw data (do not mutate series names); we'll derive displayName later
  this.StackChartData = data.Data;
      const rawCats = (listOfCategory || []).map((c: any) => (c == null ? '' : String(c)));
      const catStripK = this.computeCommonHierarchyStripCount(rawCats);
      this.cleanedCategories = rawCats.map((c: string) =>
        this.formatHierarchyDisplay(c, catStripK)
      );
         this.dataSharingService.tableSorting$.subscribe(({sortColumn, sortDirection}) => {     
      if (sortColumn && this.StackChartData && this.StackChartData.length > 0) {     
        this.sortColumn = sortColumn;
        this.sortDirection = sortDirection;
      }
    });
  
    this.dataSharingService.ColorDictionarySubject$.subscribe((colors:any)=>{
      if(colors)
      {
          this.colorDictionary=colors;
      }
    });
      // Pass original listOfCategory so filtering by "Category Name" still works
  this.renderChart2('stack-chart-container', this.StackChartData, this.ChartProperties, chartType, listOfCategory);

    });

    // Listen to table sorting changes
 
  }
  

  constructor(
    private http: HttpClient,
    private stackService: StackchartServiceService,
    private dataSharingService: CrosstabService,
    private significanceService: SignificanceService
  ) { }

  getData(): Observable<any> {
    return this.http.get<any>('assets/Data/StackData.json');
  }

  seriesObject: any = {};
  // accessSeriesValues(islowSample: any, listOfCategory: any) {
  //   const seriesObjects: any = {};
  //   const categories: string[] = [];
  //   const signi: any[] = [];
  //   const signi2: any[] = [];
  //   const changes: any[] = [];
  //   const sampleSizeValues: any[] = [];
  //   let IB = this.InsufficientBaseSample;
  //   // let orderedList = Array.isArray(listOfCategory) ? [...listOfCategory] : [];
  //   //  if (this.sortColumn) {
  //   //     const findIndex = orderedList.findIndex((c: any) => this.cleanText(c) === this.cleanText(this.sortColumn));
  //   //    if (findIndex > 0) {
  //   //      const [moved] = orderedList.splice(findIndex, 1);
  //   //      orderedList.unshift(moved);
  //   //    }
  //   //  }
  //   //   if (this.cleanedCategories && Array.isArray(listOfCategory) && orderedList.length) {
  //   //   this.chartCategories = orderedList.map((c: any) => {
  //   //     const origIdx = listOfCategory.indexOf(c);
  //   //     return origIdx >= 0 ? this.cleanedCategories[origIdx] : (c ?? '');
  //   //   });
  //   // } else {
  //   //   this.chartCategories = orderedList;
  //   // }
  //   for (const catName of listOfCategory) {
  //     //  for (const catName of orderedList) {
  //     const data = this.StackChartData.filter(a => a["Category Name"] == catName);
  //     const uniqueKeys = ["Category Name", "Series Name"];
  //     let uniqueData = this.getUnique(data, uniqueKeys);
  //     if(this.cleanText(catName) === this.cleanText(this.sortColumn)){
  //     uniqueData = this.sortSeriesDataByDataArray(uniqueData, this.sortDirection);
  //     }
  //     for (const series of uniqueData) {
  //       const seriesName = series["Series Name"] || series.name;
  //       let numericValue = (series["Rounded Value"] == "NA" ? 0.000001 : (parseFloat(series["Rounded Value"]) == null) ? 0.000001 : parseFloat(series["Sample size"]) < IB ? 0.000001 : parseFloat(series["Rounded Value"]));
  //       let label = (series.Label);
  //       const change = parseFloat(series["Change value vs PY"]);
  //       const significance = parseFloat(series["Significance"]);
  //       const category = series["Category Name"];
  //       const sampleSize = series["Sample size"];
  //       const significance2 = series["Significance1"];
  //       const color = series["color"];
  //       // Check if chartProperties.showNegative is false and series has negative values
  //       if (!this.ChartProperties.showNegative && numericValue < 0) {
  //         continue; // Skip this series
  //       }

  //       let finalvalue = numericValue;

  //       if (!seriesObjects[seriesName]) {
  //         seriesObjects[seriesName] = {
  //           name: seriesName,
  //           data: [],
  //           label: [],
  //           changeValue: [],
  //           significanceValue: [],
  //           visible: true,
  //           pointWidth: 45,
  //           samplesize: [],
  //           // color: color
  //         };
  //       }

  //       seriesObjects[seriesName].data.push(finalvalue);
  //       seriesObjects[seriesName].label.push(label);
  //       seriesObjects[seriesName].changeValue.push(change);
  //       seriesObjects[seriesName].significanceValue.push(significance);
  //       seriesObjects[seriesName].samplesize.push(sampleSize);
  //       // seriesObjects[seriesName].color.push(color);
  //       if (!categories.includes(category)) {
  //         categories.push(category);
  //       }

  //       signi2.push(significance2);
  //       sampleSizeValues.push(sampleSize);
  //       changes.push(change);
  //     }
  //   }
  //   this.changeValue = [];
  //   this.significanceValue = [];
  //   this.seriesData = Object.values(seriesObjects).map((item: any) => {
  //     return {
  //       name: item.name,
  // displayName: this.trimAfterColon(item.name),
  //       data: item.data,
  //       label: item.label,
  //       color: item.color,
  //       changeValue: item.changeValue,
  //       visible: item.visible,
  //       significanceValue: item.significanceValue,
  //       pointWidth: item.pointWidth,
  //       showInlegend: item.showInLegend,
  //       samplesize: item.samplesize,
  //     };
  //   });
  //   // Reverse seriesData
  //   this.seriesData.reverse();

  //   // Immediately trim legend names (text after last ':') so only new names ever render
   

  //   // Iterate through reversed seriesData to construct changeValue array
  //   for (const item of this.seriesData) {
  //     this.changeValue.push(...item.changeValue);
  //     this.significanceValue.push(...item.significanceValue);
  //   }

  //   this.sampleSizeValues = sampleSizeValues;
  //   this.significanceValue2 = signi2;
  //    this.chartCategories = listOfCategory;
  // }

  accessSeriesValues(islowSample: any, listOfCategory: any) {
  const seriesObjects: any = {};
  const categories: string[] = [];
  const signi: any[] = [];
  const signi2: any[] = [];
  const changes: any[] = [];
  const sampleSizeValues: any[] = [];
  let IB = this.InsufficientBaseSample;

  const uniqueSeriesLabels = [
    ...new Set(
      this.StackChartData.map((r: any) => r['Series Name']).filter((n: any) => n != null && String(n) !== '')
    ),
  ].map((n: any) => String(n));
  const seriesStripK = this.computeCommonHierarchyStripCount(uniqueSeriesLabels);
  
  // Determine the series order from sortColumn if it exists
  let seriesOrder: string[] = [];
  if (this.sortColumn) {
    const sortColumnData = this.StackChartData.filter(
      a => this.cleanText(a["Category Name"]) === this.cleanText(this.sortColumn)
    );
    const uniqueKeys = ["Category Name", "Series Name"];
    let uniqueSortData = this.getUnique(sortColumnData, uniqueKeys);
    uniqueSortData = this.sortSeriesDataByDataArray(uniqueSortData, this.sortDirection);
    seriesOrder = uniqueSortData.map(series => series["Series Name"] || series.name);
  }

  for (const catName of listOfCategory) {
    const data = this.StackChartData.filter(a => a["Category Name"] == catName);
    const uniqueKeys = ["Category Name", "Series Name"];
    let uniqueData = this.getUnique(data, uniqueKeys);
    
    if (this.cleanText(catName) === this.cleanText(this.sortColumn)) {
      uniqueData = this.sortSeriesDataByDataArray(uniqueData, this.sortDirection);
    } else if (seriesOrder.length > 0) {
      // Sort uniqueData to match the series order from sortColumn
      uniqueData.sort((a, b) => {
        const aName = a["Series Name"] || a.name;
        const bName = b["Series Name"] || b.name;
        const aIndex = seriesOrder.indexOf(aName);
        const bIndex = seriesOrder.indexOf(bName);
        
        // If both are in seriesOrder, sort by their position
        if (aIndex !== -1 && bIndex !== -1) {
          return aIndex - bIndex;
        }
        // If only a is in seriesOrder, it comes first
        if (aIndex !== -1) return -1;
        // If only b is in seriesOrder, it comes first
        if (bIndex !== -1) return 1;
        // If neither is in seriesOrder, maintain original order
        return 0;
      });
    }
    
    for (const series of uniqueData) {
      const seriesName = series["Series Name"] || series.name;
      const rv = series["Rounded Value"];
      let numericValue = (rv == "NA" ? 0.000001 : (parseFloat(series["Rounded Value"]) == null) ? 0.000001 : parseFloat(series["Sample size"]) < IB ? 0.000001 : parseFloat(series["Rounded Value"]));
      const SENTINEL = Stackedbarchart1Component.INVALID_STACK_VALUE;
      let invalidStackCause: 'na' | 'is' | null = null;
      if (numericValue === SENTINEL) {
        if (rv == "NA" || rv === "NA" || parseFloat(series["Rounded Value"]) == null) {
          invalidStackCause = 'na';
        } else {
          invalidStackCause = 'is';
        }
      }
      let label = (series.Label);
      const change = parseFloat(series["Change value vs PY"]);
      const significance = parseFloat(series["Significance"]);
      const category = series["Category Name"];
      const sampleSize = series["Sample size"];
      const significance2 = series["Significance1"];
      const color = series["color"];
      
      // Check if chartProperties.showNegative is false and series has negative values
      if (!this.ChartProperties.showNegative && numericValue < 0) {
        continue; // Skip this series
      }

      let finalvalue = numericValue;

      if (!seriesObjects[seriesName]) {
        seriesObjects[seriesName] = {
          name: seriesName,
          data: [],
          label: [],
          changeValue: [],
          significanceValue: [],
          visible: true,
          pointWidth: 45,
          samplesize: [],
          invalidStackCause: [],
        };
      }

      seriesObjects[seriesName].data.push(finalvalue);
      seriesObjects[seriesName].label.push(label);
      seriesObjects[seriesName].changeValue.push(change);
      seriesObjects[seriesName].significanceValue.push(significance);
      seriesObjects[seriesName].samplesize.push(sampleSize);
      seriesObjects[seriesName].invalidStackCause.push(invalidStackCause);
      
      if (!categories.includes(category)) {
        categories.push(category);
      }

      signi2.push(significance2);
      sampleSizeValues.push(sampleSize);
      changes.push(change);
    }
  }
  
  this.changeValue = [];
  this.significanceValue = [];
  
  // Convert seriesObjects to array and sort by seriesOrder if it exists
  let seriesArray = Object.values(seriesObjects);
  if (seriesOrder.length > 0) {
    seriesArray.sort((a: any, b: any) => {
      const aIndex = seriesOrder.indexOf(a.name);
      const bIndex = seriesOrder.indexOf(b.name);
      
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;
      return 0;
    });
  }
  
  this.seriesData = seriesArray.map((item: any) => {
    return {
      name: item.name,
      displayName: this.formatHierarchyDisplay(String(item.name), seriesStripK),
      data: item.data,
      label: item.label,
      color: item.color,
      changeValue: item.changeValue,
      visible: item.visible,
      significanceValue: item.significanceValue,
      pointWidth: item.pointWidth,
      showInlegend: item.showInLegend,
      samplesize: item.samplesize,
      invalidStackCause: item.invalidStackCause ?? [],
    };
  });
  
  // Reverse seriesData
  this.seriesData.reverse();

  // Iterate through reversed seriesData to construct changeValue array
  for (const item of this.seriesData) {
    this.changeValue.push(...item.changeValue);
    this.significanceValue.push(...item.significanceValue);
  }

  this.sampleSizeValues = sampleSizeValues;
  this.significanceValue2 = signi2;
  this.chartCategories = listOfCategory;
}
  customization() {
    return this.stackService.customizationStack();
  }
  
  getSigLowerLimit() {
    return this.significanceService.getSigLowerLimit(this.DefaultConfidenceLevel);
  }
  
  getSigUpperLimit() {
    return this.significanceService.getSigUpperLimit(this.DefaultConfidenceLevel);
  }
sortSeriesDataByDataArray(
  seriesData: any[],
  direction: 'asc' | 'desc' | 'ascd' = 'ascd'
): any[] {

  // If ascd → return original array without sorting
  if (direction === 'ascd') {
    return seriesData;
  }

  return [...seriesData].sort((a, b) => {
    const valA = Number(a.Value) || 0;
    const valB = Number(b.Value) || 0;

    return direction === 'desc' ? valB - valA : valA - valB;
  });
}

  private static readonly INVALID_STACK_VALUE = 0.000001;

  private buildConsolidatedNaIsScatterSeries(chartType: string, insufficientBase: number): any | null {
    const seriesData = this.seriesData;
    if (!seriesData?.length) {
      return null;
    }
    const numCats = seriesData[0].data?.length ?? 0;
    if (numCats < 1) {
      return null;
    }
    const isBar = chartType === 'bar';
    const points: any[] = [];
    const SENTINEL = Stackedbarchart1Component.INVALID_STACK_VALUE;

    for (let j = 0; j < numCats; j++) {
      const allInvalid = seriesData.every((s: any) => s.data[j] === SENTINEL);
      if (!allInvalid) {
        continue;
      }
      const insufficientAt = (s: any) => {
        const c = s.invalidStackCause?.[j];
        if (c === 'is') {
          return true;
        }
        if (c === 'na') {
          return false;
        }
        const ss = Number(s.samplesize[j]);
        return ss !== 0 && !isNaN(ss) && ss < insufficientBase;
      };
      const naStyleOnlyAt = (s: any) => {
        const c = s.invalidStackCause?.[j];
        if (c === 'na') {
          return true;
        }
        if (c === 'is') {
          return false;
        }
        const ss = Number(s.samplesize[j]);
        const insufficient = ss !== 0 && !isNaN(ss) && ss < insufficientBase;
        return !insufficient && s.data[j] === SENTINEL;
      };
      const allInsufficientOnly = seriesData.every(insufficientAt);
      const allNaOnly = seriesData.every(naStyleOnlyAt);
      const text: string = allInsufficientOnly
        ? STACK_CONSOLIDATED_ONLY_INSUFFICIENT
        : allNaOnly
          ? STACK_CONSOLIDATED_ONLY_NA
          : STACK_CONSOLIDATED_MIXED;
      for (const s of seriesData) {
        s.data[j] = null;
      }
      if (isBar) {
        points.push({
          x: 0,
          y: j,
          marker: { enabled: false, radius: 0 },
          custom: { consolidatedText: text }
        });
      } else {
        points.push({
          x: j,
          y: 0,
          marker: { enabled: false, radius: 0 },
          custom: { consolidatedText: text }
        });
      }
    }

    if (!points.length) {
      return null;
    }

    const showDL = this.ChartProperties.showDataLabel;
    const textColor = this.ChartProperties.darkTheme ? 'white' : 'black';

    return {
      type: 'scatter',
      name: '__consolidatedNaIs',
      showInLegend: false,
      enableMouseTracking: false,
      clip: false,
      data: points,
      dataLabels: {
        enabled: showDL,
        useHTML: true,
        allowOverlap: true,
        crop: false,
        overflow: 'allow' as any,
        ...(isBar
          ? { align: 'left' as any, verticalAlign: 'middle' as any, x: 8 }
          : { align: 'center' as any, verticalAlign: 'bottom' as any, y: -4 }),
        formatter: function (this: any) {
          const t = this.point?.custom?.consolidatedText;
          return t
            ? "<div style='font-size: 0.7rem;text-align: center;color:" + textColor + "'>" + t + '</div>'
            : '';
        }
      }
    };
  }


  renderChart2(container2: any, seriesdata: any, properties: any, chartType: string, listOfCategory: any) {

    localStorage.setItem("properties", JSON.stringify(properties));
    this.accessSeriesValues(this.ChartProperties.datalabelStyle == 'lowSample', listOfCategory);
    // Replace chartCategories with cleaned display versions if available
     this.chartCategories = this.cleanedCategories;
    let change = this.changeValue;
    let signi = this.significanceValue;
    let sampleSizeValues = this.sampleSizeValues;
    let signi2 = this.significanceValue2;
    let maxDataValue = 0;
    const sumArray = new Array<number>();
    let i = 0;
    if(this.colorDictionary.length==0)
    {
    if (this.ChartProperties.gradientBarColor) {
      this.seriesData.forEach((series, index) => {
        series.color = this.stackService.customColors1[index % this.stackService.customColors1.length]; // Assign colors from customColors1
      });
    }
    //color: this.properties.pattern ? this.getPattern() : this.properties.gradientColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],
    else if (this.ChartProperties.pattern) {
      this.seriesData.forEach((series, index) => {
        series.color = this.stackService.PatterncustomColors[index % this.stackService.PatterncustomColors.length]; // Assign colors in a cyclical manner
      });
    }
    else {
      let indexData = this.seriesData.length - 1;
      this.seriesData.forEach((series, index) => {
        series.color = this.stackService.customColors[indexData];
        indexData--;// Assign colors from customColors2
      });
    }
    let ColorDictionary:any=[];
       this.seriesData.forEach((series, index) => {
        ColorDictionary.push({name:series.name.replace(/\s+/g, ""),color:series.color})
      });
      this.dataSharingService.setColorDictionary(ColorDictionary);
    }else{
       this.seriesData.forEach((series, index) => {
             let customcolor =  this.colorDictionary.find((x: any)=>x.name==series.name.replace(/\s+/g, ""));
        series.color = customcolor.color;
      
      });
    }
    const consolidatedScatterSeries = this.buildConsolidatedNaIsScatterSeries(
      chartType === 'bar' ? 'bar' : 'column',
      this.InsufficientBaseSample
    );
    if (this.seriesData.length > 0) {
      // Initialize sumArray with zeros
      this.seriesData[0].data.forEach(() => sumArray.push(0));
      // Sum up values of each series at each index
      this.seriesData.forEach(series => {
        series.data.forEach((value: any, index: any) => {
          sumArray[index] += value;
        });
      });
      maxDataValue = Math.max(...sumArray);
      maxDataValue = maxDataValue + Math.ceil(maxDataValue * 0.01);
    }

    const yAxisMaxValue = this.ChartProperties.stacking ? 100 : maxDataValue;

    const updatedCategories = this.stackService.updatedCategories;

    const updatedCategoryNames = updatedCategories.map(category => category.image);
    let plotBandsConfig: { color: string; from: number; to: number; }[] = [];
    const numPlotBands = this.chartCategories.length;

    if (this.ChartProperties.plotBands) {
      for (let i = 0; i < numPlotBands; i += 2) {
        const from = i + 0.5;
        const to = from + 1;
        plotBandsConfig.push({ color: this.ChartProperties.darkTheme ? this.stackService.plotBandsdark : this.stackService.plotBandsColor, from, to });
      }
    }
    let InsufficientBase = this.InsufficientBaseSample;
    let lowSample = this.LowBaseSample;

    let sigLowerValue = this.getSigLowerLimit();
    let sigUpperValue = this.getSigUpperLimit();
    const containerEl = document.getElementById(container2);
    if (!containerEl) { return; }
    this.chart = Highcharts.chart(containerEl, {
      chart: {
        type: chartType,
        backgroundColor: this.ChartProperties.darkTheme ? this.stackService.darkThemebg : this.stackService.lightThemebg,
        style: {
          color: this.ChartProperties.darkTheme ? this.stackService.darkThemeTextColor : this.stackService.lightThemeTextColor,
          fontFamily:"KantarBrown-Regular"
        }
      },
      exporting: {
        enabled: false
      },

      legend: {
        ...this.stackService.customizeLegend(this.ChartProperties.showLegend, this.ChartProperties.legendPosition, this.ChartProperties),
        labelFormatter: function (this: any) {
          const uo = this.userOptions || {};
          return uo.displayName != null && uo.displayName !== ''
            ? uo.displayName
            : this.name;
        },
      },

      title: {
        text: '',
        align: this.ChartProperties.chartTitlePosition,
        style: {
          color: this.ChartProperties.darkTheme ? this.stackService.darkThemeTextColor : this.stackService.lightThemeTextColor,
          marginleft: '4%',
          fontSize: '24px',
          fontFamily: this.stackService.textfont
        }
      },

      accessibility: {
        point: {
          valueDescriptionFormat: '{index}. {point.name}, fat: {point.x}g, sugar: {point.y}g, {point.change}g.'
        }
      },
      xAxis: {

        visible: true,
        lineWidth: 1,
        categories: this.chartCategories,
        min: 0,
        
        max: this.chartCategories.length > 10 ? 9 : this.chartCategories.length - 1,
        scrollbar: {
          enabled: this.chartCategories.length > 9 ? true : false,
          height: 6, // Adjust the height of the scrollbar as needed
          barBackgroundColor: '#999',
          barBorderRadius: 3,
          barBorderWidth: 0,
          //barBorderColor: '#c9c9c9',
          buttonBackgroundColor: 'transparent',
          buttonBorderWidth: 0,
          buttonArrowColor: '#aaa',
          //buttonBorderRadius: 0,
          rifleColor: 'transparent',
          trackBackgroundColor: '#f5f5f5',
          trackBorderWidth: 0,
          //trackBorderColor: 'black',
          trackBorderRadius: 3,
          barHoverStyle: {
            backgroundColor: '#444444' 
          }
        },
        labels: {
          rotation: this.stackService.xAxisLabelOrientation(this.ChartProperties.axisLabelOrientation, this.ChartProperties),
          //useHTML: true,
          //style: {
          //  color: this.ChartProperties.darkTheme ? this.stackService.darkThemeTextColor : this.stackService.lightThemeTextColor,
          //},
          //formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
          //  if (properties.axisImage) {
          //    var index = this.axis.categories.indexOf(String(this.value));
          //    var category = updatedCategories[index];
          //    if (category && category.image) {
          //      return '<span style="display: inline-block; width: 20px; height: 20px; background: url(' + category.image + ') no-repeat center center; background-size: cover;"></span>';
          //    } else {
          //      return '<span>No Image</span>';
          //    }
          //  } else {
          //    return String(this.value);
          //  }
          //},
        },
        plotBands: plotBandsConfig,
      },
      yAxis: {
        visible: false,
        gridLineWidth: this.ChartProperties.gridlines,
        labels: {
          style: {
            color: this.ChartProperties.darkTheme ? this.stackService.darkThemeTextColor : this.stackService.lightThemeTextColor,
          },
        },
        plotLines: [{
          value: 0,
          width: 1
        }],
        max: 100,
        //max: yAxisMaxValue,
        title: {
          text: '',
          fontFamily: this.stackService.textfont
        },
        stackLabels: {
          enabled: false,
        },
      },
      credits: {
        enabled: false
      },

      tooltip: {
        enabled: true,
        borderWidth: 0,
        useHTML: true,
        shape: properties.toolTipStyle == "style1" ? 'square' : 'callout',
        shadow: false,
        backgroundColor: 'rgba(0,0,0,0)',


        formatter: function (this: any): string | false {
          if (this.series.name === 'Marker1') return false;
          if (this.series.name === '__consolidatedNaIs') return false;

          const dotColor = this.series.color; // Get the series color
          let content =
            `<div style="background-color: #f5f5f5; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
            ` ${(this.series.userOptions && this.series.userOptions.displayName) ? this.series.userOptions.displayName : this.series.name}` +
            `<div style="display: block; margin-top: 5px;"><strong>Value:</strong>` +
            `${this.series.userOptions.samplesize[this.point.x] != 0 && this.series.userOptions.samplesize[this.point.x] < InsufficientBase ? 'I/S' :
              this.y == 0.000001 ? 'NA' :
                (this.series.userOptions.samplesize[this.point.x] < lowSample && this.series.userOptions.samplesize[this.point.x] > InsufficientBase) ?
                  (this.y + (properties.datalabelFormat == "percentage" ? '%' : '') + ('*')) :
                  (this.y + (properties.datalabelFormat == "percentage" ? '%' : ''))}` +
            `</div>`;

          if (properties.datalabelStyle == "change") {
            this.Sig_LowerLimt = sigLowerValue;
            this.Sig_UpperLimt = sigUpperValue;
            let changevspy = (isNaN(this.series.userOptions.changeValue[this.point.x]) ? "NA" : ('' + this.series.userOptions.changeValue[this.point.x] + (properties.datalabelFormat == "percentage" ? '%' : '') + ''));
            let sig = this.series.userOptions.significanceValue[this.point.x];
            let color = 'black';
            if (changevspy !== 'NA') {
              if (sig < this.Sig_LowerLimt) {
                color = 'red';
              } else if (sig > this.Sig_UpperLimt) {
                color = 'green';
              }
            }
            // Add a little space between label and value
            if (changevspy == '(NA)') {
              content += `<div style="display:flex;align-items:center;"><strong style="margin-right:4px;">Change:</strong><div>${changevspy}</div></div>`;
            } else {
              content += `<div style="display:flex;align-items:center;"><strong style="margin-right:4px;">Change:</strong><div style="color:${color};font-weight:bold;">${changevspy}</div></div>`;
            }
          }
          return content + '</div>';
        },

      },

      plotOptions: {
        column: { 
          stacking: 'percent',
          shadow: this.ChartProperties.shadow ? {
            color: 'rgba(0, 0, 0, 0.5)',
            offsetX: 1,
            offsetY: 1,
            opacity: 0.5,
            width: 6,
          } : false,
          dataLabels:
          {
            allowOverlap: false,//this.ChartProperties.allowOverlap,
            enabled: this.ChartProperties.showDataLabel,
            color: 'black',
            inside: true,
            align: this.ChartProperties.dataLabelPosition,
            rotation: this.ChartProperties.datalabelOrientation,
            useHTML: true,
            x:50,
            style: {
              backgroundColor: 'transparent',
              shadow: false,
              borderWidth: 0,
              textOutline: 'none',
              borderRadius: 0,
            },
            formatter: function (this: any) {
              let strColor = "white";
              let strColor2 = "black";
              if (properties.datalabelStyle == "change") {
                this.Sig_LowerLimt = sigLowerValue;
                // this.DefaultConfidenceLevel == '95%'
                //   ? COMMON_CONSTANTS.SigLowerLimit_95
                //   : this.DefaultConfidenceLevel == '90%'
                //     ? COMMON_CONSTANTS.SigLowerLimit_90
                //     : this.DefaultConfidenceLevel == '99%'
                //       ? COMMON_CONSTANTS.SigLowerLimit_99
                //       : COMMON_CONSTANTS.SigLowerLimit_95;
                this.Sig_UpperLimt = sigUpperValue;
                // this.DefaultConfidenceLevel == '95%'
                //   ? COMMON_CONSTANTS.SigUpperLimit_95
                //   : this.DefaultConfidenceLevel == '90%'
                //     ? COMMON_CONSTANTS.SigUpperLimit_90
                //     : this.DefaultConfidenceLevel == '99%'
                //       ? COMMON_CONSTANTS.SigUpperLimit_99
                //       : COMMON_CONSTANTS.SigUpperLimit_95;

                let text = this.y == 0.000001 ? 'NA' : this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                // Wrap change value in parentheses when available
                let changevspy = (isNaN(this.series.userOptions.changeValue[this.point.x])
                  ? "(NA)"
                  : ('(' + this.series.userOptions.changeValue[this.point.x] + (properties.datalabelFormat == "percentage" ? '%' : '') + ')'));
                let sig = this.series.userOptions.significanceValue[this.point.x];
                const sampleSize = this.series.userOptions.samplesize[this.point.x];

                  // NA base
                if (text == 'NA') {
                  return (
                    '<div><div style="font-size: 0.7rem;text-align: center;color:' + strColor2 + '">' + text + '</div></div>'
                  );
                }
                // Insufficient base always overrides everything else
                if (sampleSize != 0 && sampleSize < InsufficientBase) {
                  return (
                    '<div><div style="font-size: 0.7rem;text-align: center;color:' + strColor2 + '">I/S</div></div>'
                  );
                }
              
                // Low base add *
                if (sampleSize < lowSample && sampleSize > InsufficientBase) {
                  text = text + '*';
                }
                if (changevspy == '(NA)') {
                  return (
                    '<div><div style="font-size: 0.7rem;text-align: center;color:' + strColor2 + '">' + text + '</div><div style="margin-top: 3px;text-align: center;">' + changevspy + '</div><div>'
                  );
                }
                else if (sig < this.Sig_LowerLimt) {
                  return (
                    '<div style="width: 30px;"><div style="font-size: 0.7rem;text-align: center;color:' + strColor2 + '">' + text + '</div><div  style="margin-top: 3px;text-align: center;color: red;width: 100%;display: flex;"><div style="width: 75%;">' + changevspy + '</div><div style="width: 25%;"></div></div></div>'
                  )
                } else if (sig > this.Sig_UpperLimt) {
                  return (
                    '<div style="width: 30px;"><div style="font-size: 0.7rem;text-align: center;color:' + strColor2 + '">' + text + '</div><div style="margin-top: 3px;text-align: center;color: green;width: 100%;display: flex;"><div style="width: 75%;">' + changevspy + '</div><div style="width: 25%;"></div></div></div>'
                  )
                }
                else {
                  return (
                    '<div><div style="font-size: 0.7rem;text-align: center;color:' + strColor2 + '">' + text + '</div><div style="margin-top: 3px;text-align: center;width: 100%">' + changevspy + '</div></div>'
                  );
                }


                //let text = this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') + '(' + change[c++] + ')' : 'NA';
                //return (
                //  '<span >' + text + '</span>'
                //);

              }
              if (this.series.userOptions.samplesize[this.point.x] == "0" && this.y == 0.000001) {
                return ("<div style='font-size: 0.7rem;text-align: center;color:black'>NA</div>");
              }
              else {
                if (this.series.userOptions.samplesize[this.point.x] != 0 && this.series.userOptions.samplesize[this.point.x] < InsufficientBase) {
                  return ("<div style='font-size: 0.7rem;text-align: center;color:black'>I/S</div>");
                }
                else {
                  if (this.y == 0.000001)
                    return ("<div style='font-size: 0.7rem;text-align: center;color:black'>NA</div>")
                  else {
                    if (this.series.userOptions.samplesize[this.point.x] < lowSample && this.series.userOptions.samplesize[this.point.x] > InsufficientBase)
                      return ("<div style='font-size: 0.7rem;text-align: center;color:black'>" + (this.y + (properties.datalabelFormat == "percentage" ? '%' : '') + ('*')) + "</div>")
                    else
                      return ("<div style='font-size: 0.7rem;text-align: center;color:black'>" + (this.y + (properties.datalabelFormat == "percentage" ? '%' : '')) + "</div>")
                  }
                }
              }
              // return this.series.userOptions.samplesize[this.point.x] == "0" && this.y == 0.000001 ? "<div style='white'>NA</div>" : this.series.userOptions.samplesize[this.point.x] < InsufficientBase ? "<div style='white'>I/S</div>" : this.y == 0.000001 ? "<div style='white'>NA</div>" : (this.series.userOptions.samplesize[this.point.x] < lowSample && this.series.userOptions.samplesize[this.point.x] > InsufficientBase) ? "<div style='white'>"+(this.y + (properties.datalabelFormat == "percentage" ? '%' : '') + ('*'))+"</div>" : "<div style='white'>"+(this.y + (properties.datalabelFormat == "percentage" ? '%' : ''))+"</div>";
            },
          },
          pointWidth: 45,
        },
        bar: {
       stacking: 'percent',
          shadow: this.ChartProperties.shadow ? {
            color: 'rgba(0, 0, 0, 0.5)',
            offsetX: 1,
            offsetY: 1,
            opacity: 0.5,
            width: 6,
          } : false,
          dataLabels:
          {
            allowOverlap: false,//this.ChartProperties.allowOverlap,
            enabled: this.ChartProperties.showDataLabel,
            color: 'black',
            align: this.ChartProperties.dataLabelPosition,
            rotation: this.ChartProperties.datalabelOrientation,
            useHTML: true,
            style: {
              backgroundColor: 'transparent',
              shadow: false, // Remove shadow
              borderWidth: 0,
              textOutline: 'none',
              borderRadius: 0,
            },
            formatter: function (this: any) {
              let strColor = "white";
              let strColor2 = "black";
              if (properties.datalabelStyle == "change") {
                this.Sig_LowerLimt = sigLowerValue;
                // this.DefaultConfidenceLevel == '95%'
                //   ? COMMON_CONSTANTS.SigLowerLimit_95
                //   : this.DefaultConfidenceLevel == '90%'
                //     ? COMMON_CONSTANTS.SigLowerLimit_90
                //     : this.DefaultConfidenceLevel == '99%'
                //       ? COMMON_CONSTANTS.SigLowerLimit_99
                //       : COMMON_CONSTANTS.SigLowerLimit_95;
                this.Sig_UpperLimt = sigUpperValue;
                // this.DefaultConfidenceLevel == '95%'
                //   ? COMMON_CONSTANTS.SigUpperLimit_95
                //   : this.DefaultConfidenceLevel == '90%'
                //     ? COMMON_CONSTANTS.SigUpperLimit_90
                //     : this.DefaultConfidenceLevel == '99%'
                //       ? COMMON_CONSTANTS.SigUpperLimit_98
                //       : COMMON_CONSTANTS.SigUpperLimit_95;

                let text = this.y == 0.000001 ? 'NA' : this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                // Wrap change value in parentheses when available
                let changevspy = (isNaN(this.series.userOptions.changeValue[this.point.x])
                  ? "(NA)"
                  : ('(' + this.series.userOptions.changeValue[this.point.x] + (properties.datalabelFormat == "percentage" ? '%' : '') + ')'));
                let sig = this.series.userOptions.significanceValue[this.point.x];
                const sampleSize = this.series.userOptions.samplesize[this.point.x];
              if (text == 'NA') {
                  return (
                    '<div><div style="font-size: 0.7rem;text-align: center;color:' + strColor2 + '">' + text + '</div></div>'
                  );
                }
                if (sampleSize != 0 && sampleSize < InsufficientBase) {
                  return (
                    '<div><div style="font-size: 0.7rem;text-align: center;color:' + strColor2 + '">I/S</div></div>'
                  );
                }
               
                if (sampleSize < lowSample && sampleSize > InsufficientBase) {
                  text = text + '*';
                }
                if (changevspy == 'NA') {
                  return (
                    '<div><div style="font-size: 0.7rem;text-align: center;color:' + strColor2 + '">' + text + '</div><div style="margin-top: 3px;text-align: center;">' + changevspy + '</div><div>'
                  );
                }
                if (sig < this.Sig_LowerLimt) {
                  return (
                    '<div style="font-size: 0.7rem;width: 30px;"><div style="text-align: center;color:' + strColor2 + '">' + text + '</div><br><div  style="margin-top: 3px;text-align: center;color: red;width: 100%;display: flex;"><div style="width: 75%;">' + changevspy + '</div><div style="width: 25%;"></div></div></div>'
                  )
                } else if (sig > this.Sig_UpperLimt) {
                  return (
                    '<div style="font-size: 0.7rem;width: 30px;"><div style="text-align: center;color:' + strColor2 + '">' + text + '</div><br><div style="margin-top: 3px;text-align: center;color: green;width: 100%;display: flex;"><div style="width: 75%; ">' + changevspy + '</div><div style="width: 25%;"></div></div></div>'
                  )
                }
                else {
                  return (
                    '<div><div style="font-size: 0.7rem;text-align: center;color:' + strColor2 + '">' + text + '</div><div style="margin-top: 3px;text-align: center;width: 100%;">' + changevspy + '</div></div>'
                  );
                }


                //let text = this.y != 0 ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') + '(' + change[c++] + ')' : 'NA';
                //return (
                //  '<span >' + text + '</span>'
                //);

              }
              if (this.series.userOptions.samplesize[this.point.x] == "0" && this.y == 0.000001) {
                return ("<div style='font-size: 0.7rem;text-align: center;color:black'>NA</div>");
              }
              else {
                if (this.series.userOptions.samplesize[this.point.x] != 0 && this.series.userOptions.samplesize[this.point.x] < InsufficientBase) {
                  return ("<div style='font-size: 0.7rem;text-align: center;color:black'>I/S</div>");
                }
                else {
                  if (this.y == 0.000001)
                    return ("<div style='font-size: 0.7rem;text-align: center;color:black'>NA</div>")
                  else {
                    if (this.series.userOptions.samplesize[this.point.x] < lowSample && this.series.userOptions.samplesize[this.point.x] > InsufficientBase)
                      return ("<div style='font-size: 0.7rem;text-align: center;color:black'>" + (this.y + (properties.datalabelFormat == "percentage" ? '%' : '') + ('*')) + "</div>")
                    else
                      return ("<div style='font-size: 0.7rem;text-align: center;color:black'>" + (this.y + (properties.datalabelFormat == "percentage" ? '%' : '')) + "</div>")
                  }
                }
              }
              //return this.series.userOptions.samplesize[this.point.x] == "0" && this.y == 0.000001 ? "NA" : this.series.userOptions.samplesize[this.point.x] < InsufficientBase ? 'I/S' : this.y == 0.000001 ? 'NA' : (this.series.userOptions.samplesize[this.point.x] < lowSample && this.series.userOptions.samplesize[this.point.x] > InsufficientBase) ? (this.y + (properties.datalabelFormat == "percentage" ? '%' : '') + ('*')) : (this.y + (properties.datalabelFormat == "percentage" ? '%' : ''));
            },

          },

          pointWidth: 45,
        },
        series: {
          groupPadding: 0.01,
          pointPadding: 0.25,
        },
        scatter: {
          states: {
            hover: { enabled: false },
            inactive: { enabled: false }
          }
        }

      },
      series: consolidatedScatterSeries
        ? [...this.seriesData, consolidatedScatterSeries]
        : this.seriesData
    } as any);

  }

  commonfunc(event: any, customization: string, options: any) {
    this.event = event;
    this.stackService.commonFunc(customization, event, this.ChartProperties)
    this.renderChart2('stack-chart-container', this.data['data'], this.ChartProperties, "", "");
  }

  patternselect(ispattern: boolean) {
    this.ChartProperties.pattern = ispattern
    this.accessSeriesValues(this.ChartProperties.datalabelStyle == 'lowSample', "");
    this.renderChart2('stack-chart-container', this.data['data'], this.ChartProperties, "", "");
  }
  userselectedproperties() {
    this.data["properties"][0].showPattern = this.ChartProperties.pattern;
    this.data["properties"][0] = this.ChartProperties;
    return JSON.stringify(this.data).toString();
  }

  getUnique(arr: any[], keys: string[]): any[] {
    const map = new Map<string, any>();
    arr.forEach(item => {
      const compositeKey = keys.map(key => item[key]).join('|');
      if (!map.has(compositeKey)) {
        map.set(compositeKey, item);
      }
    });
    return Array.from(map.values());
  }
        cleanText(str: string): string {
        if (!str) return '';

        return str
          .replace(/[|:]/g, '')  
          .replace(/\s+/g, '')   
          .trim()
          .toLowerCase();     
      }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null as any;
    }
  }
}
